import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
/**
 * The breadcrumb for one confirmed review's own page (EPF-S92): "Review 26-236854-6" once the review's lab id
 * is known, "Review" until then or when the read fails.
 *
 * The module contract's `PortalModuleRoute.breadcrumb` takes a component for a crumb that has to read its own
 * data, and the shell renders it inside this module's own provider, so it reaches the same transport and query
 * cache the page does. It asks for the identical query (`reviewDetailQueryOptions`, same key), so on a page that
 * is already open this is answered from the cache and adds no request of its own.
 */
import { usePortalModuleTransport } from '@equerranz/portal-module-contract';
import { useQuery } from '@tanstack/react-query';
import { COA_SLUG } from './acceptanceReferences.js';
import { reviewDetailQueryOptions } from './coaReviews.js';
export function CoaReviewDetailBreadcrumb({ params }) {
    const transport = usePortalModuleTransport(COA_SLUG);
    const detail = useQuery(reviewDetailQueryOptions(transport, params['id'] ?? ''));
    return _jsx(_Fragment, { children: detail.data === undefined ? 'Review' : `Review ${detail.data.labId}` });
}
export default CoaReviewDetailBreadcrumb;
//# sourceMappingURL=CoaReviewDetailBreadcrumb.js.map